import styled from 'styled-components'

export const InputDiv = styled.div`
  height: fit-content;
  position: relative;
  width: 100%;
`

export const Label = styled.label<{ disabled?: boolean }>`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  font-weight: 700;
  display: block;
  margin-bottom: 0.5rem;
  color: ${(props) => props.disabled ? '#7A7A7A' : '#333'};
  transition: color 0.2s ease-in-out;
`

export const Input = styled.input`
  width: 100%;
  height: 32px !important;
  padding: 0 16px !important;
  box-sizing: border-box !important;
  background-color: #EBEBEB;
  border: 1px solid transparent;
  border-radius: 20px;
  color: #696969;
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  outline: none;
  transition: border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out, background-color 0.2s ease-in-out;
  cursor: text;
  
  &:hover:not(:disabled) {
    border-color: #cbd5e0;
  }
  
  &:focus {
    border-color: #3182ce;
    box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.1);
  }
  
  &:disabled {
    background-color: #D3D3D3;
    cursor: default;
  }
  
  &::placeholder {
    color: #696969;
    font-style: italic;
  }
  
  &.clientToFreight{
    width: 90%;
  }
`

export const SearchOptions = styled.ul`
  position: absolute;
  list-style: none;
  z-index: 9100;
  width: 100%;
  top: 4.5rem;
  border-radius: 1rem;
  border: 1px solid #EBEBEB;
  overflow-x: hidden;
  max-height: 10rem;
  overflow-y: auto;
  background-color: #FFF;
  
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #c0c0c0;
    border-radius: 10px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #ffffff;
    border-radius: 10px;
    border: 2px solid #c0c0c0;
  }
`

export const Option = styled.li<{isSelected?:boolean}>`
  font-family: 'Inter', sans-serif;
  font-size: 12px;
  cursor: pointer;
  padding: .8rem 1rem;
  background-color: ${props => props.isSelected ? '#F4F4F4' : '#FFF'};
  border-bottom: 1px solid #EBEBEB;
  user-select: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  span {
    display: block;
  }
  
  &:hover {
    background-color: #F4F4F4;
  }
`